export default __webpack_public_path__ + "static/media/EM0540.34I-22667_-15281_0.08484503.jpg";